export default __webpack_public_path__ + "static/cruiselines-royal-ship-3-89ec5403f6ca8a828cb1c7180a6a73d7.jpg";